exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._1HSowMwvzLkqhKBEwxa2y8{width:300px}html[dir] ._2ngqnsmMTZS5v3sbKWRBFf{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"container": "_1HSowMwvzLkqhKBEwxa2y8",
	"fileProvidersToAddContainer": "_2ngqnsmMTZS5v3sbKWRBFf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/options/config/mail/owa-storage-accounts-option/lib/components/StorageAccountsFull.scss
// module id = 5003
// module chunks = 2